export var HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
export var PRODUCT_HOME_BREAKPOINT = 1280;
export var CREATE_BREAKPOINT = 1130;
export var varSearchFocusBorderColor = '--ds--ans--fbc';
export var varSearchHoverBackgroundColor = '--ds--ans--hbgc';
export var varSearchBackgroundColor = '--ds--ans--bgc';
export var varSearchColor = '--ds--ans--c';
export var varSearchBorderColor = '--ds--ans--bc';